const DEFAULT_LOCALE = "en-US" /* enUS */;

export { DEFAULT_LOCALE };
//# sourceMappingURL=src-constants-locale.js.map
